// JsFromRoutes CacheKey 13fe7654fb768ee50e44845bec93d958
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/brokers/operations_batches'),
  indexGet: /* #__PURE__ */ definePathHelper('get', '/brokers/operations_batches/*path'),
}
